{
	"1": {
		"part1": ["Great!", "Success!", "Good work!"],
		"part2": [
			"Congratulations.",
			"Lovely stuff.",
			"Nicely done.",
			"You got there.",
			"Kudos to you.",
			"Well done."
		],
		"part3": ["Bish bash bosh.", "Keep it up!", "That will do nicely.", "Very good."]
	},
	"2": {
		"part1": ["Splendid!", "Success!", "Good work!"],
		"part2": [
			"Congratulations.",
			"Lovely stuff.",
			"Nicely done.",
			"Kudos to you.",
			"Well done."
		],
		"part3": ["Bish bash bosh.", "Keep it up!", "That will do nicely.", "Very good."]
	},
	"3": {
		"part1": ["Impressive!", "Great!", "Superb!", "Awesome!", "Bosh!", "Hot diggity dog!"],
		"part2": ["Well done.", "Jolly good stuff.", "Canny effort.", "Good effort.", "Bravo."],
		"part3": [
			"You did good kid.",
			"That was snazzy.",
			"That was very good.",
			"That was lovely.",
			"You did marvellously.",
			"I like it. Have some stars.",
			"I am thrilled for you.",
			"You rock."
		]
	},
	"4": {
		"part1": [
			"Magnificent!",
			"Excellent!",
			"Bingo bango!",
			"Bonanza!",
			"Fantastic!",
			"Wonderful!",
			"Terrific!",
			"Back of the net!",
			"Buckaroo!",
			"Sublime!"
		],
		"part2": [
			"Top job.",
			"Great work.",
			"Top class stuff.",
			"Wow.",
			"Wowee.",
			"Wowzers.",
			"Good golly.",
			"Good golly Miss Molly.",
			"Good gracious.",
			"Gosh.",
			"Golly gee whiz.",
			"Crikey.",
			"By Jove.",
			"Hats off to you."
		],
		"part3": [
			"You are very good at this.",
			"You are rather good at this.",
			"That was brilliant.",
			"That was marvellous.",
			"That was superb.",
			"That was spiffy.",
			"That was exquisite.",
			"That was very clever.",
			"That was snazzy.",
			"You’re really going to town."
		],
		"special": [["You go Glen Coco!", "Four stars for you Glen Coco!"]]
	},
	"5": {
		"part1": [
			"Genius!",
			"Perfect!",
			"Incredible!",
			"Wondrous!",
			"Fandabidozi!",
			"Heavens to Betsy!",
			"Jiminy Jillikers!",
			"Jumping Jelly Sticks!",
			"Great Scott!",
			"Cor blimey, guv'nor!",
			"Blimey O'Riley!",
			"Mighty Mittens!",
			"Beard of Zeus!",
			"Odin's Raven!",
			"O Frabjous Day!",
			"Callooh! Callay!"
		],
		"part2": [
			"A perfect game.",
			"Top notch.",
			"Glorious.",
			"Remarkable.",
			"Astonishing.",
			"Fabulous.",
			"Astounding.",
			"Phenomenal.",
			"Tremendous.",
			"Exquisite."
		],
		"part3": [
			"*chef's kiss*",
			"You can't get better than that.",
			"You have serious talent.",
			"That was a delight to behold.",
			"What a dazzling performance.",
			"That was wonderful.",
			"That was majestic.",
			"That was magnificent.",
			"You nailed it.",
			"You're my hero."
		]
	},
	"globalPerformance": [
		"Wowzah, that's in the world by the way!",
		"That makes you a world-class player!",
		"Cracking effort, that's globally by the way!",
		"That's better than the average player!",
		"You smashed the global average!",
		"Not too shabby, with a score like that i'd get gabby!",
		"A score like that could win the OWS olympics!",
		"Spiffing, that's one for the wall of fame!",
		"Incredible, you're one of our best players!",
		"Belting, you're the best of the best!",
		"You're a global sensation!",
		"You're among the elite players worldwide!",
		"You were even faster than Glen Coco!"
	]
}
